export const BREAKPOINTS = {
  XSMALL: 481,
  SMALL: 768,
  MEDIUM: 1024,
};

export const BORDER_RADIUS = '15px';
export const RADIUS = '0.625rem';
